import './code-scanner.scss';

import { createElementFromHTML, tryParseJSON } from '../../js/helper';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import * as ScanditSDK from 'scandit-sdk';
import { AjaxLoader } from '../../js/ajax-loader';
// import { Barcode, BarcodePicker, ScanSettings, configure } from 'scandit-sdk';

class CodeScanner {
    constructor ($codeScanner, options) {
        const defaults = {
            initAttr: 'data-productsupport-filter',
            fieldAttr: 'data-input',
            filterAttr: 'filter',
            resultAttr: 'result',
            resetAttr: 'reset',
            loader: null,
            onSubmitted: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$codeScanner = $codeScanner;
        this.licenseKey = $codeScanner.getAttribute('data-apikey');
        this.picker = undefined;

        this.$startButton = this.$codeScanner.querySelector('[data-code-scanner="start"]');
        this.$closeButton = this.$codeScanner.querySelector('[data-code-scanner="close"]');
        this.$okButton = this.$codeScanner.querySelector('[data-code-scanner="ok"]');
        this.$productButton = this.$codeScanner.querySelector('[data-code-scanner="product"]');

        this.$scannerWrapper = this.$codeScanner.querySelector('[data-code-scanner="scanner-wrapper"]');
        this.$scanner = this.$codeScanner.querySelector('[data-code-scanner="scanner"]');
        this.checkUri = this.$codeScanner.getAttribute('data-url');

        this.$resultOverlay = this.$codeScanner.querySelector('[data-code-scanner="result-overlay"]');
        this.$resultText = this.$codeScanner.querySelector('[data-code-scanner="result-text"]');

        this.$header = document.querySelector('[data-header="root"]');

        this.scanningMessage = this.$codeScanner.getAttribute('data-message-scanning');
        this.successMessage = this.$codeScanner.getAttribute('data-message-success');
        this.errorMessage = this.$codeScanner.getAttribute('data-messformage-error');

        if (this.settings.loader !== null) {
            this.$loader = createElementFromHTML(this.settings.loader);
        }
    }

    init () {
        this.bindEvents();
    }

    bindEvents () {
        if (this.$startButton) {
            this.$startButton.addEventListener('click', (e) => {
                this.initCodeScanner();
                this.showScanner();
                e.preventDefault();
            });
        }

        if (this.$closeButton) {
            this.$closeButton.addEventListener('click', () => {
                this.hideScanner();
            });
        }

        if (this.$okButton) {
            this.$okButton.addEventListener('click', () => {
                this.hideResult();
            });
        }
    }

    initCodeScanner () {
        ScanditSDK.configure(this.licenseKey, {
            engineLocation: 'https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build/'
        }).then(() => {
            return ScanditSDK.BarcodePicker.create(this.$scanner, {
                playSoundOnScan: true,
                vibrateOnScan: true,
                guiStyle: 'viewfinder'
                // targetScanningFPS: 15
            }).then((barcodePicker) => {
                this.picker = barcodePicker;

                const windowWidth = window.innerWidth;
                const windowHeight = window.innerHeight;

                const targetWidth = 150;
                const targetHeight = 100;

                const searchWidth = 1 / windowWidth * targetWidth;
                const searchHeight = 1 / windowHeight * targetHeight;

                const xPos = (1 - searchWidth) / 2;
                const yPos = (1 - searchHeight) / 2;

                // Create the settings object to be applied to the scanner
                const scanSettings = new ScanditSDK.ScanSettings({
                    enabledSymbologies: [
                        'dotcode'
                    ],
                    codeDuplicateFilter: 1000,
                    searchArea: { x: xPos, y: yPos, width: searchWidth, height: searchHeight }
                    // searchArea: { x: 0.2, y: 0.4, width: 0.6, height: 0.2 }
                });

                // set color invert on dot code
                const dotCodeSetting = scanSettings.getSymbologySettings(ScanditSDK.Barcode.Symbology.DOTCODE);
                dotCodeSetting.setColorInvertedEnabled(true);

                this.picker.applyScanSettings(scanSettings);

                this.picker.on('scan', scanResult => {
                    const scanMessage = scanResult.barcodes.reduce(function (string, barcode) {
                        return barcode.data;
                    }, '');
                    this.showResult(scanMessage);
                    this.picker.pauseScanning();
                });

                this.picker.on('scanError', error => {
                    this.showResult(error.message);
                });

                this.picker.resumeScanning();
                this.showScanner();
            });
        });
    }

    showScanner () {
        this.$scannerWrapper.classList.add('code-scanner__scanner-wrapper--visible');
        disableBodyScroll(this.$scannerWrapper);

        document.body.classList.add('has--codescanner');
        if (this.$header) {
            this.$header.classList.add('has--overlay');
        }
    }

    hideScanner () {
        this.$scannerWrapper.classList.remove('code-scanner__scanner-wrapper--visible');
        enableBodyScroll(this.$scannerWrapper);

        if (this.picker) {
            this.picker.destroy();
        }

        document.body.classList.remove('has--codescanner');
        if (this.$header) {
            this.$header.classList.remove('has--overlay');
        }
    }

    showResult (message) {
        // message = '1912413';
        this.$resultText.innerHTML = this.scanningMessage + '<br />' + message;

        if (this.$loader) {
            this.$resultText.appendChild(this.$loader);
        }

        this.$resultOverlay.classList.add('is--visible');

        this.checkCode(message, (resultJSON) => {
            if (resultJSON && resultJSON.success === true) {
                this.$resultText.innerHTML = this.successMessage + '<br />' + message;
                if (this.$productButton && typeof resultJSON.url !== 'undefined') {
                    this.$resultOverlay.classList.add('has--success');
                    this.$productButton.setAttribute('href', resultJSON.url);
                } else {
                    const target = this.$codeScanner.getAttribute('data-target');
                    if (target && typeof resultJSON.product !== 'undefined') {
                        const $targetField = document.querySelector(target);
                        if ($targetField) {
                            $targetField.value = resultJSON.product;
                        }
                    }
                    this.hideResult();
                    this.hideScanner();
                }
            } else {
                this.$resultText.innerHTML = this.errorMessage + '<br />' + message;
                this.$resultOverlay.classList.add('has--error');
            }
        });
    }

    hideResult () {
        this.$resultOverlay.classList.remove('is--visible');
        this.$resultOverlay.classList.remove('has--success');
        this.$resultOverlay.classList.remove('has--error');

        if (this.picker) {
            this.picker.resumeScanning();
        }
    }

    checkCode (code, callback) {
        this.checkCodeResult = new AjaxLoader(this.checkUri + code, {
            onSuccess: (resultText) => {
                const result = tryParseJSON(resultText);

                if (result !== false) {
                    callback(result);
                }
            }
        });
    }
}

export { CodeScanner };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $codeScanner = $context.querySelector('[data-code-scanner="root"]');

        if ($codeScanner) {
            const codeScanner = new CodeScanner($codeScanner, {
                loader: window.OPTIONS.loader
            });
            codeScanner.init();
        }
    }
});
